<template>
  <div v-bind:class="{'now_loading': (this.loading)}">
    <div v-show="loading" class="loader loader_bg--gray"></div>
    <div v-show="!loading" v-for="(val, n) in productList" :key="n" class="products_wrap beauty_wrap bg_white mt12 pt16 pb24 boxs2">
      <h2 class="content_title">{{ val.genreName }}</h2>

      <p v-if="val.genreId == 3" class="pl16 pr16 mt16 nselection_text ab">しおDASの定期購入を変更する、または停止する場合はテレフォンオーダーへご連絡ください。<br>テレフォンオーダー 0120-934-258 平日9時-18時（土・日・祝日休み）</p>
      <div class="product_list">

        <div class="product_item" v-for="(item, index) in val.itemList" v-bind:class="{ 'select': item.repeatOrder, 'disabled': item.goodDeal }" v-on:click="!item.goodDeal ? selectItem(n, index) : null">

          <div class="products_main">
            <div class="product_image">
              <img :src="imagePath + item.product.imagePath" :alt="item.product.productName" v-on:error="imageError" :data-noimage="imagePath + item.product.noImagePath">

            </div>
            <h3 class="product_title">{{ item.product.productName }}</h3>
          </div>
          <div class="products_detail">
            <p class="product_price rb"><span class="yen">￥</span>{{ item.product.price.toLocaleString() }}</p>
            <p class="product_point rb"><span class="point">P</span>{{ item.product.point.toLocaleString() }}</p>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import RepeatOrder from '@/components/api/repeatOrder'
import Config from '@/config/config'

export default {
  props: ['bc'],
  data() {
    return {
      imagePath: Config.APIURL,
      loading: true,
      nowBC: null,
      productList: [],
      existRepeatItem: [],
      cartItemList: []
    }
  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    selectItem(n, index) {
      if(this.productList[n].itemList[index].goodDeal) {
        return;
      }
      if(this.productList[n].genreId == 3) return;
      if(this.productList[n].itemList[index].repeatOrder) {
        this.productList[n].itemList[index].repeatOrder = false;
        this.productList[n].itemList[index].orderCount = 1;
        this.productList[n].itemList[index].childFund = false;
      } else {
        this.productList[n].itemList[index].repeatOrder = true;
      }
    },

    getProducts() {
      RepeatOrder.getRepeatOrder(this.nowBC).then((val) => {
        console.log(val);
        for (var i = 0; i < val.productGenreList.length; i++) {
          let items = {
            genreId: val.productGenreList[i].genreId,
            genreName: val.productGenreList[i].genreName,
            itemList: []
          }
          for (var a = 0; a < val.repeatOrderList.length; a++) {
            if(val.productGenreList[i].genreId == val.repeatOrderList[a].product.genre.genreId) {
              let repeatOrder = val.repeatOrderList[a];
              items.itemList.push(repeatOrder);
              if(val.repeatOrderList[a].repeatOrder) {
                this.existRepeatItem.push(val.repeatOrderList[a]); // すでに定期購入している商品リスト
                // this.cartItemList.push(val.repeatOrderList[a]); // 選択している商品のリスト
              }
            }
          }
          if (items.itemList.length != 0) {
            this.productList.push(items);
          }
        }
        localStorage.setItem('existRepeatItem', JSON.stringify(this.existRepeatItem))
        this.$emit('existRepeatItem', this.existRepeatItem);
        this.loading = false;
      });
    },
    storageGetProducts(repeatItem) {
      this.productList.push(...repeatItem);
      const storageExistRepeatItem = JSON.parse(localStorage.getItem('existRepeatItem'))
      storageExistRepeatItem ? this.existRepeatItem.push(...storageExistRepeatItem): ''; // すでに定期購入している商品リスト
      // for (var i = 0; i < repeatItem.length; i++) {
      //   for (var a = 0; a < repeatItem[i].itemList.length; a++) {
      //     repeatItem[i].itemList[a].repeatOrder ? this.cartItemList.push(repeatItem[i].itemList[a]) : ''; // 選択している商品のリスト
      //   }
      // }
      this.$emit('existRepeatItem', this.existRepeatItem);
      this.loading = false;
    },
    async init() {
      if(this.productList.length != 0) {
        this.productList.splice(this.productList.length, 0)
      }
      // console.log(this.productList);
      const repeatItem = JSON.parse(localStorage.getItem('repeatItemList'));
      repeatItem ? this.storageGetProducts(repeatItem) : await this.getProducts();
    }
  },
  watch: {
    productList: {
      deep: true,
      handler() {
        localStorage.setItem('repeatItemList', JSON.stringify(this.productList));
      }
    },
    bc: function() {
      this.nowBC = this.bc;
      this.init();
    }
  },
  created() {
    if(this.bc) {
      this.nowBC = this.bc;
    } else {
      this.nowBC = localStorage.getItem('subNowBC');
    }


    this.init();

  }
}
</script>

<style lang="css" scoped>
.nselection_text {
  font-size: 14px;
}

.product_item.disabled {
  cursor: not-allowed;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/subscription/ProductList.vue